import styled from "styled-components";

export const LegalPage = styled.div`
  width: 90rem;
  max-width: 90%;
  margin: auto;
  position: relative;
  padding-top: 4.5rem;

  @media screen and (max-width: 768px) {
    padding-top: 2.5rem;
    max-width: 90%;
  }
`;

export const PrivacyPageWrapper = styled.div`
  flex-direction: column;
  display: flex;
  padding-top: 1rem;
  padding-bottom: 2.5rem;
  grid-column: 3 / span 7;

  @media screen and (max-width: 768px) {
    grid-column: 1 / span 4;
    padding-bottom: 1.875rem;
  }
`;

export const Title = styled.h1`
  display: flex;
  flex-direction: column;
  color: #222222;
  font-size: 3.75rem;
  font-family: "Days One", sans-serif;
  font-weight: 400;
  line-height: 1.6;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  margin-bottom: 3.75rem;
  text-align: center;

  @media screen and (max-width: 768px) {
    font-size: 2.5rem;
    letter-spacing: 0.1625rem;
    margin: 1rem 0 4rem 0;
  }
`;

export const Paragraph = styled.p`
  color: #222222;
  line-height: 1.6;
  letter-spacing: 0.03em;
  font-size: 1.5rem;
  font-family: "arial";
  font-weight: 400;
  margin-bottom: 3.75rem;

  @media screen and (max-width: 768px) {
    font-size: 1.5rem;
    letter-spacing: 0.03em;
    margin-bottom: 1.25rem;
  }
`;

export const Header = styled.header``;

export const Main = styled.main``;

export const PrivacySection = styled.section``;

export const Subtitle = styled.h3`
  color: #222222;
  font-size: 1.5rem;
  font-family: "Days One", sans-serif;
  line-height: 1.6;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  margin-bottom: 2.5rem;
  font-weight: 600;
  padding: 1rem 0 0 0;

  @media screen and (max-width: 768px) {
    font-size: 1.5rem;
    margin-bottom: 1.25rem;
    line-height: 1.6;
    letter-spacing: 0.03em;
    font-weight: 600;
    padding: 2rem 0 0.5rem 0;
  }
`;

export const SubParagraph = styled.p`
  color: #222222;
  font-size: 1.5rem;
  font-family: "arial";
  font-weight: 400;
  line-height: 1.6;
  letter-spacing: 0.03em;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 3.75rem;

  .bulletPoint {
    margin-left: 3rem;
    display: flex;
    gap: 3rem;
  }

  @media screen and (max-width: 768px) {
    font-size: 1.5rem;
    line-height: 1.6;
    letter-spacing: 0.03em;
    font-weight: 400;
    margin-bottom: 1.25rem;
  }
`;

export const SubContent = styled.div`
  display: flex;
  flex-direction: column;
`;
